import { Grid, Box } from "@mui/material";
import { styled } from "@mui/system";
import React from "react";
import QuoteGeneratorForm from "../../components/QuoteGeneratorForm";

const SiteLayout = styled(Grid)(({ theme }) => ({
  backgroundColor:'white',
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  backgroundPosition: "center",
  padding: '0 16px',
  [theme.breakpoints.up("sm")]: {
    padding: '0 32px',
  },
  [theme.breakpoints.up("md")]: {
    padding: '0 64px',
  },
  [theme.breakpoints.up("lg")]: {
    padding: '0 100px',
  },
}));





const SiteLayoutContent = styled(Box)(({ theme }) => ({
  padding: "24px",
  margin: "16px 0",
  background: "#fff",
  borderRadius: "10px",
  display: "block",
}));

export default function QuoteGenerator() {
  return (
    <SiteLayout container>
      <Grid item xs={12}>
        <SiteLayoutContent>
          <QuoteGeneratorForm />
        </SiteLayoutContent>
      </Grid>
    </SiteLayout>
  );
}
